import React, { useEffect, useState, useRef } from "react";
import Button from "./Button";
import Pie from "./Pie";
import Form from "./Form";

const Summary = ({ blocks, labels, langId, baseColors, scanResult, categories, colors, handleClick, questions }) => {
    const [weakest, setWeakest] = useState(null);
    const [strongest, setStrongest] = useState(null);
    const [rapport, setRapport] = useState(null);
    const [mode, setMode] = useState("results");
    const componentRef = useRef(null);


    useEffect(() => {


        if (questions) {

            let dataArray = [];
            Object.values(questions).map((question, index) => {

                question.index = index;
                dataArray.push(question);
            });


            let highest = [...dataArray];
            dataArray.sort((b, a) => b.score - a.score);
            highest.sort((b, a) => a.score - b.score);
            highest = highest.slice(0, 1);

            dataArray = dataArray.slice(0, 3);

            setStrongest(highest);
            setWeakest(dataArray);



        }
    }, [questions]);

    useEffect(() => {



        if (mode === "results") {

            if (componentRef.current && componentRef.current.innerHTML) {


                setRapport(componentRef.current.innerHTML);
            }
        }




    }, [mode, componentRef.current]);

    function goToEnd() {
        setMode("end");
        window.scrollTo({
            top: 0,
            behavior: "smooth", // makes it smooth
        });

    }
    return <div className="space-y-5 mb-5" >


        {(weakest &&
            <>


                {(mode === "start" &&



                    <>
                        <div className="info mx-auto text-left">


                            <p>Proficiat! Je kijkt naar je 3 tijdcompetenties en 13 vaardigheden, zoals je ze zelf scoorde!</p><p>
                                Een competentie is een unieke combinatie van persoonskenmerken, houding, kennis en vaardigheden die zich uiten in zichtbaar gedrag dat -op dat specifiek vlak- naar succes leidt.
                                Je kan absoluut iedere competentie -tot op bepaald niveau- ontwikkelen door op de onderliggende vaardigheden te werken!</p><p>
                                Én je kan -een keer je maximum bereikt- ook gebruik maken van je alternatieve competenties of ... je levenslang laten begeleiden in je minder sterke punten. Dat noemt dan een huwelijk ;-).
                                Je merkt: veel is mogelijk!
                            </p>
                        </div>
                        <Button onClick={() => setMode("results")}>Bekijk jouw resultaten</Button>
                    </>)}

                {(mode === "results" &&

                    <>
                        <div>
                            <Pie langId={langId} handleClick={handleClick} colors={colors} baseColors={baseColors} startCategories={categories} startQuestions={questions} />


                            <div className="info mx-auto" dangerouslySetInnerHTML={{ __html: blocks?.["zelfscan---congrats"]?.lang?.[langId]?.blocks }}></div>




                        </div>
                        <div ref={componentRef} className=" mb-5 space-y-5">


                            <h3 className="font-bold text-lg" >{labels?.["score-high-on"]?.lang?.[langId]?.name}</h3>


                            <div >


                                {Object.values(strongest).map((question, index) => (


                                    <div onClick={(e) => handleClick(e, question)} className="flex cursor-pointer space-x-3 justify-center items-center" key={"summary_" + index}>

                                        <div style={{ backgroundColor: colors[question.index] }} className="w-6 h-6 rounded-full"></div>
                                        <div><span className="underline">{question?.lang[langId]?.title}</span> ({question.score}  / 10)</div>


                                    </div>
                                ))}
                            </div>

                            <div className="info mx-auto" dangerouslySetInnerHTML={{ __html: blocks?.["zelfscan---reward"]?.lang?.[langId]?.blocks }}></div>




                            <h3 className="font-bold text-lg " >{labels?.["score-low-on"]?.lang?.[langId]?.name}</h3>

                            <div className="space-y-2">


                                {Object.values(weakest).map((question, index) => (


                                    <div onClick={(e) => handleClick(e, question)} className="flex cursor-pointer space-x-3 justify-center items-center" key={"summary_" + index}>

                                        <div style={{ backgroundColor: colors[question.index] }} className="w-6 h-6 rounded-full"></div>
                                        <div><span className="underline">{question?.lang[langId]?.title}</span> ({question.score}  / 10)</div>


                                    </div>
                                ))}
                            </div>
                        </div>


                        <div className="mx-auto info" dangerouslySetInnerHTML={{ __html: blocks?.["zelfscan---rose"]?.lang?.[langId]?.blocks }}></div>




                        <div>



                            <div className="mt-5">
                                <Button onClick={() => goToEnd()}>   {labels?.["forward-result"]?.lang?.[langId]?.name}</Button>
                            </div>

                        </div>


                    </>

                )}

                {(mode === "end" &&

                    <div>

                        <Form labels={labels} langId={langId} blocks={blocks} questions={questions} scanResult={scanResult} rapport={rapport} setMode={setMode} />

                        <Pie langId={langId} handleClick={handleClick} colors={colors} baseColors={baseColors} startCategories={categories} startQuestions={questions} />



                    </div>
                )}



            </>
        )}

    </div >
}

export default Summary;
